export default "__VITE_ASSET__cZ8kHA8Z__"